// src/components/PolicyPage.jsx
import React, { useState } from "react";
import "./PolicyPage.css";

const PolicySection = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="policy-section">
      <h3 className="policy-title" onClick={() => setOpen(!open)}>
        {title} {open ? "" : ""}
      </h3>
      {open && <p className="policy-text">{children}</p>}
    </div>
  );
};

const PolicyPage = () => {
  return (
    <div className="policy-page">
      <header className="policy-header">
        <h1>Vår Policy</h1>
        <p>Här hittar du information om hur vi hanterar data och ansvar.</p>
      </header>

      <main className="policy-main">
        <PolicySection title="Integritetspolicy / GDPR">
          Vi samlar in personuppgifter som namn, e-post och telefonnummer endast när
          du kontaktar oss eller använder våra tjänster. All information lagras säkert och
          används endast för att förbättra våra tjänster. Du kan när som helst begära
          borttagning av dina uppgifter.
        </PolicySection>

        <PolicySection title="Cookie-policy">
          Vi använder cookies för att förbättra webbplatsens funktion och analysera
          trafik. Du kan välja att acceptera eller neka cookies vid besök.
        </PolicySection>

        <PolicySection title="Ansvarsfriskrivning">
          Informationen på vår webbplats är endast vägledande och kan innehålla
          felaktigheter. Vi tar inget ansvar för beslut baserade på informationen här.
        </PolicySection>

        <PolicySection title="Användarvillkor">
          Material på webbplatsen får inte kopieras, distribueras eller användas
          utan vårt tillstånd. Genom att använda sidan accepterar du våra villkor.
        </PolicySection>

        <PolicySection title="Marknadsföring & kommunikation">
          Vi kan använda kontaktinformation för att skicka nyhetsbrev eller erbjudanden.
          Du kan alltid avregistrera dig via länk i e-post eller genom kontakt.
        </PolicySection>

        <PolicySection title="Säkerhet">
          Vi skyddar din data med säker lagring och SSL-kryptering. Vi gör vårt bästa
          för att hålla informationen trygg.
        </PolicySection>

        <PolicySection title="Kontakt">
          Har du frågor om vår policy, kontakta oss på:
          <br />
          <a href="mailto:info@dinmaklareahus.se">info@dinmaklareahus.se</a>
          <br />
          eller ring: +46 708 24 04 72
        </PolicySection>
      </main>
    </div>
  );
};

export default PolicyPage;
